import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function usePresence(teamId: string | null, currentUserId: string | null) {
  const [onlineMemberIds, setOnlineMemberIds] = useState<string[]>([]);

  useEffect(() => {
    if (!teamId || !currentUserId) {
      setOnlineMemberIds([]);
      return;
    }

    let channel: ReturnType<typeof supabase.channel> | null = null;
    let cancelled = false;

    const connect = () => {
      if (channel) return;
      channel = supabase.channel(`presence:${teamId}`, {
        config: { presence: { key: currentUserId } },
      });

      channel
        .on('presence', { event: 'sync' }, () => {
          if (!channel || cancelled) return;
          const state = channel.presenceState();
          setOnlineMemberIds(Object.keys(state));
        })
        .subscribe(async (status) => {
          if (status === 'SUBSCRIBED' && channel && !cancelled) {
            await channel.track({ online_at: new Date().toISOString() });
          }
        });
    };

    const disconnect = () => {
      if (channel) {
        try { channel.unsubscribe(); } catch { /* noop */ }
        channel = null;
      }
    };

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') connect();
      else disconnect();
    };

    if (document.visibilityState === 'visible') connect();
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', handleVisibility);
      disconnect();
    };
  }, [teamId, currentUserId]);

  return { onlineMemberIds };
}
